import { HStack, Button, Text } from '@chakra-ui/react';
import LanguageSwitcher from '@/components/LanguageSwitcher';
import React from 'react';
import { NavigationBarProps } from '..';
import { CONSOLE_ROOT_PATH, REGISTER_PAGE_PATH } from '@/routes/path';
import Link from '@/components/Link';

const DesktopNavigation: React.VFC<NavigationBarProps> = ({
  t,
  scrollToShowcases,
  scrollToFeatures,
  scrollToPricing,
}) => {
  return (
    <>
      <HStack>
        <Button colorScheme="blue" variant="link" onClick={scrollToFeatures}>
          {t('feature')}
        </Button>
      </HStack>
      {/* <HStack>
        <Button colorScheme="blue" variant="link" onClick={scrollToShowcases}>
          {t('showcase')} 事例 Cases
        </Button>
      </HStack> */}
      <HStack>
        <Button colorScheme="blue" variant="link" onClick={scrollToPricing}>
          {t('pricing')}
        </Button>
      </HStack>
      <HStack>
        <Text>|</Text>
      </HStack>
      {/* <HStack>
        <Link target="_blank" to={CONSOLE_ROOT_PATH}>
          <Button colorScheme="blue" variant="link">
            {t('sign_in')}
          </Button>
        </Link>
      </HStack>
      <HStack>
        <Link target="_blank" to={REGISTER_PAGE_PATH}>
          <Button colorScheme="blue" rounded="full" variant="solid" w="200px">
            {t('sign_up_landing_page')}
          </Button>
        </Link>
      </HStack> */}
      <HStack>
        <LanguageSwitcher buttonTextColor="black" optionTextColor="black" />
      </HStack>
    </>
  );
};

export default DesktopNavigation;
